import styled from 'styled-components'
import { LookButton, buttonLook } from 'components/Buttons/look'

export const Container = styled.div`
  justify-content: center;
  align-items: center;
`

export const Content = styled.div`
  width: 100%;
  padding: 5px;
  justify-content: center;
  align-items: center;
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  gap: 10px;
`

export const InfoText = styled.p`
  color: #000000;
  font-size: 16px;
  text-align: center;
`

export const Title = styled(InfoText)`
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 15px;
`

export const SubTitle = styled(Title)`
  font-size: 16px;
`

export const ButtonText = styled(SubTitle)`
  color: #FFFFFF;
  margin: 0px;
  font-weight: 200;
`

export const Button = styled(LookButton).attrs({ type: 'button' }).attrs(buttonLook({ variant: 'secondary' }))`
  width: 100px;
  align-self: center;
  margin-top: 10px;
`
